// Android hardware back button handling for the Cordova app.
//
// React Router records the session-history position in `window.history.state.idx`
// (0 at the app's first/root entry, incremented on every push). While in-app
// history remains we navigate back; at the root we close the app instead of
// doing nothing.

export const resolveBackButtonAction = (historyState) => {
  const idx = historyState?.idx;
  return typeof idx === 'number' && idx > 0 ? 'back' : 'exit';
};

// Close the app. `navigator.app.exitApp` is provided by cordova-android core,
// so no extra plugin is required.
export const exitApp = () => {
  window.navigator?.app?.exitApp?.();
};

export const handleBackButton = (e) => {
  e.preventDefault();
  if (resolveBackButtonAction(window.history.state) === 'back') {
    window.history.back();
    return;
  }
  exitApp();
};
